// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"a923b56ad73ca15f","5285":"caa3039984ec7c6c"}[chunkId] + ".css";
};